/**
 * OS-1723 — formato de montos de la consola. Moneda base COP (ISO 4217); siempre se muestra el
 * símbolo y el código para no confundir pesos con dólares (antes el KPI decía "USD estimado").
 */
export const BASE_CURRENCY = 'COP';

const formatters = new Map<string, Intl.NumberFormat>();

function formatter(currency: string): Intl.NumberFormat {
  let current = formatters.get(currency);
  if (!current) {
    current = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    formatters.set(currency, current);
  }
  return current;
}

/** `200000` → `$ 200.000 COP`; `null` → `—`. */
export function formatMoney(amount: number | null | undefined, currency = BASE_CURRENCY): string {
  if (amount === null || amount === undefined || !Number.isFinite(amount)) {
    return '—';
  }
  return `${formatter(currency).format(amount)} ${currency}`;
}

/** `12.5` → `12,5 %`. */
export function formatPercent(value: number): string {
  return `${new Intl.NumberFormat('es-CO', { maximumFractionDigits: 2 }).format(value)} %`;
}
